import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import { Button, Input, TextArea } from "@atomaro/ui-kit";
import {
  DictionaryEditContent,
  DictionaryEditFooter,
  DictionaryEditHeaderRow,
  DictionaryEditPopup,
} from "widgets/dictionaryEditModal/ui/styles.ts";
import { useEffect, useMemo, useState } from "react";
import { useApiariesStore } from "entities/apiaries";
import { useDictionariesStore } from "entities/dictionaries";
import { IDictionary } from "shared/types";
import { AddDictionaryParams } from "entities/dictionaries/model/types";
import { COLORS } from "shared/consts";

export const DictionaryEditModal = ({
  typeHandler,
  isMobile,
}: {
  typeHandler:"EDIT" | "ADD" | "dictionaryName"| null;
  isMobile: boolean;
}) => {

  const isOpen = useDictionariesStore((s) => s.isEditModalOpen);
  const openId = useDictionariesStore((s) => s.editOpenId);
  const close = useDictionariesStore((s) => s.closeEditModal);

  const currentApiaryId = useApiariesStore((s) => s.currentApiaryId);
  const addDictionaryEntry = useDictionariesStore((s) => s.addDictionary);
  const updateDictionaryEntry = useDictionariesStore(
    (s) => s.updateDictionaryEntry
  );
  const dictionaries = useDictionariesStore((s) => s.dictionaries);

  const current: IDictionary | undefined = useMemo(() => {
    if (typeHandler === "dictionaryName") {
      return
    }
    if (typeHandler === "EDIT") {
      return dictionaries.find((d) => String(d.id) === String(openId));
    } else {
      return dictionaries.find((d) => String(d.type) === String(openId));
    }
  }, [dictionaries, openId, typeHandler]);

  const [name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");

  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    if (!isOpen || typeHandler === "ADD") {
      setName("");
      setDescription("");
      setError("");
      setSaving(false);
      return;
    }
    setName(String(current?.name ?? ""));
    setDescription(String(current?.description ?? ""));
    setError("");
  }, [isOpen, openId, current?.name, current?.description, typeHandler]);

  const onSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Введите термин");
      return;
    }
    if (!openId || !currentApiaryId) return;
    setSaving(true);
    try {
      const body: AddDictionaryParams = {
        apiaryId: String(currentApiaryId),
        name: trimmed,
        type: "",
        description: "",
      };
      if (current?.type) body.type = current.type;
      if (description && description.trim()) console.log(description, "cdddd");

      body.description = description.trim();
      if (typeHandler === "EDIT") {
        await updateDictionaryEntry(body, openId);
      } else if (typeHandler === "ADD") {
        await addDictionaryEntry(body);
      }
      close();
    } finally {
      setSaving(false);
    }
  };
  if (!typeHandler || !openId) return null;
  if (typeHandler !== 'EDIT' && typeHandler !== 'ADD') return null;

  return (
    <Modal
      isOpen={isOpen}
      centered
      style={{ padding: 0 }}
      maxWidth={isMobile ? "100vw" : "450px"}
      maxHeight={isMobile ? "100vh" : "auto"}
      onClickOverlay={close}
    >
      <DictionaryEditPopup key={String(openId ?? "")}>
        <DictionaryEditHeaderRow>
          <h3>{typeHandler === "EDIT" ? "Редактирование" : "Новый термин"}</h3>
          <Button
            size="s"
            variant="outline"
            colorScheme="neutral"
            onClick={close}
            iconPrefix={
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                style={{
                  fill: "none",
                }}
              >
                <rect
                  id="24 / Navigation / Close Large"
                  width="24.000000"
                  height="24.000000"
                  x="0.000000"
                  y="0.000000"
                />
                <path
                  id="Union"
                  d="M10.9401 12.0006L4.99902 17.9417L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L4.99904 6.0595L10.9401 12.0006Z"
                  fill={COLORS.FG.DEFAULT}
                  fillRule="evenodd"
                />
              </svg>
            }
          />
        </DictionaryEditHeaderRow>
        <DictionaryEditContent>
          <Input
            placeholder="Введите термин"
            name="dictionary-name"
            value={name}
            size="l"
            label="Термин"
            error={error}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError("");
            }}
            disabled={saving}
          />
          <TextArea
            id={current?.id}
            placeholder="Нет описания"
            size="l"
            label="Описание термина"
            defaultValue={current?.description}
            onChange={(e) => setDescription(e.target.value)}
            disabled={saving}
            counter={`${description.length}/2000`}
          />
        </DictionaryEditContent>
        <DictionaryEditFooter isMobile={isMobile}>
          <Button
            size={`${isMobile ? "l" : "m"}`}
            colorScheme="neutral"
            variant="ghost"
            label="Отменить"
            onClick={close}
            style={{
              width: "100%",
            }}
            disabled={saving}
          />
          <Button
            size={`${isMobile ? "l" : "m"}`}
            colorScheme="accent"
            label="Сохранить"
            onClick={onSave}
            style={{
              width: "100%",
            }}
            disabled={saving || name.length === 0}
          />
        </DictionaryEditFooter>
      </DictionaryEditPopup>
    </Modal>
  );
};
